<template>
    <!-- <div
        class="item_wrapper mb-4 justify-center"
        @click="diaryLogsMethod(dataObject.diary_id)"
    >
        <router-link
            :to="{
                path: '/diary',
                query: {
                    date: dataObject.diary_date_query || '',
                    id: dataObject.diary_id || '',
                },
            }"
            class="app_nav__link"
        >
            <div
                class="item_inner flex items-start px-3 py-4 border border-gray-200 rounded-lg"
            >
                <div class="item_left">
                    <div class="">
                        <div class="">
                            <fa
                                :icon="['fal', 'calendar']"
                                class="mr-2 text-2xl text-gray-300"
                            ></fa>
                        </div>
                    </div>
                </div>
                <div class="item_right ml-2">
                    <h4
                        class="text-sm font-medium text-black-900 leading-4 mb-2"
                        data-v-0cd87ba4=""
                    >
                        <fa :icon="['fal', 'eye']" class="mr-1 text-base"></fa>
                        <span v-html="dataObject.timeline_item_name"></span>
                    </h4>
                    <p
                        class="text-black-900 text-xs mb-2 font-light"
                        data-v-0cd87ba4=""
                    >
                        <span v-html="dataObject.diary_date"></span> -
                        <span v-html="dataObject.diary_time"></span>
                    </p>
                    <div
                        class="bottom_section flex items-center"
                        data-v-0cd87ba4=""
                    >
                        <template
                            v-for="diaryUserData in dataObject.users"
                            :key="diaryUserData"
                        >
                            <img
                                :src="getUserImage(diaryUserData.image_path)"
                                :alt="diaryUserData.first_name"
                                class="w-6 h-6 rounded-full mr-1"
                            />
                        </template>
                        <template
                            v-for="diaryPropData in dataObject.property"
                            :key="diaryPropData"
                        >
                            <span class="flex items-center mr-1">
                                <img
                                    src="/src/assets/images/property-thumb.jpg"
                                    alt=""
                                    class="h-6 mr-1"
                                />
                                <p class="text-xs font-light">
                                    23 Manor Road London W34 7UK
                                </p>
                            </span>
                        </template>
                        <template
                            v-for="diaryLabelData in dataObject.labels"
                            :key="diaryLabelData"
                        >
                            <app-label
                                :classes="diaryLabelData.color"
                                :text="diaryLabelData.name"
                            >
                            </app-label>
                        </template>
                    </div>
                </div>
            </div>
        </router-link>
    </div> -->

    <!-- === static data === -->
    <div
        class="item_wrapper mb-4 justify-center"
    >
        <router-link
            :to="{
                path: '/diary',
            }"
            class="app_nav__link"
        >
            <div
                class="item_inner flex items-start px-3 py-4 border border-gray-200 rounded-lg"
            >
                <div class="item_left">
                    <div class="">
                        <div class="">
                            <fa
                                :icon="['fal', 'calendar']"
                                class="mr-2 text-2xl text-gray-300"
                            ></fa>
                        </div>
                    </div>
                </div>
                <div class="item_right ml-2">
                    <h4
                        class="text-sm font-medium text-black-900 leading-4 mb-2"
                        data-v-0cd87ba4=""
                    >
                        <fa :icon="['fal', 'eye']" class="mr-1 text-base"></fa>
                        <span>Timeline item name</span>
                    </h4>
                    <p
                        class="text-black-900 text-xs mb-2 font-light"
                        data-v-0cd87ba4=""
                    >
                        <span>Diary date</span> -
                        <span>Diary time</span>
                    </p>
                    <div
                        class="bottom_section flex items-center"
                        data-v-0cd87ba4=""
                    >
                        <template>
                            <img
                                src="@/assets/images/user.png"
                                alt="first name"
                                class="w-6 h-6 rounded-full mr-1"
                            />
                        </template>
                        <template>
                            <span class="flex items-center mr-1">
                                <img
                                    src="/src/assets/images/property-thumb.jpg"
                                    alt=""
                                    class="h-6 mr-1"
                                />
                                <p class="text-xs font-light">
                                    23 Manor Road London W34 7UK
                                </p>
                            </span>
                        </template>
                        <template>
                            <app-label
                                classes="bg-red-500"
                                text="Missing"
                            >
                            </app-label>
                        </template>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
    <!-- === static data === -->
</template>
<script setup>
import AppLabel from '@/components/AppLabel.vue';
import { getUserImage } from '@/composables/globals';
const emits = defineEmits(['diaryLogs']);
defineProps({
    dataObject: {
        type: Object,
        default: () => {},
    },
});
const diaryLogsMethod = (diaryId) => {
    emits('diaryLogs', {
        type: 'diary',
        diary_id: diaryId,
        search_from: 'search',
    });
};
</script>
<style scoped></style>
